//Create a widget that displays the number of users in the system
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, Box } from '@mui/material';
import Panel from '../../UI/Panel/Panel';
import PeopleIcon from '@mui/icons-material/People';

export default function UserCount() {
    const [userCount, setUserCount] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get('/int/totalusers').then(response => {
            setUserCount(response.data.userCount);
            setLoading(false);
        });
    }, []);

    return (
        <Panel sx={{
            background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
            transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
            '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 25px rgba(0, 0, 0, 0.1)',
            }
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                p: 3
            }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                }}>
                    <Box sx={{
                        background: 'linear-gradient(135deg, #66bb6a 0%, #43a047 100%)',
                        borderRadius: '12px',
                        p: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <PeopleIcon sx={{ fontSize: 32, color: '#fff' }} />
                    </Box>
                    <Typography variant="h6" color='primary' sx={{
                        fontWeight: 600,
                        letterSpacing: '0.5px'
                    }}>
                        Users
                    </Typography>
                </Box>
                
                <Box sx={{ pl: 1 }}>
                    <Typography variant="h3" color='secondary' sx={{
                        fontWeight: 700,
                        animation: loading ? 'pulse 1.5s infinite' : 'none',
                        '@keyframes pulse': {
                            '0%': { opacity: 1 },
                            '50%': { opacity: 0.7 },
                            '100%': { opacity: 1 },
                        }
                    }}>
                        {loading ? '...' : userCount}
                    </Typography>
                    <Typography variant="body2" sx={{
                        color: '#5c6bc0',
                        mt: 0.5,
                        fontWeight: 500
                    }}>
                        Total Active Users
                    </Typography>
                </Box>
            </Box>
        </Panel>
    );
}